// removed by extract-text-webpack-plugin
module.exports = {"Base":"About__Base-3BS4B","Article":"About__Article-17lXL","Header":"About__Header-vl7rF","Content":"About__Content-2HKwM"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/About/About.css
 ** module id = 646
 ** module chunks = 0
 **/